import React, { useState } from "react";
import { Button, Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { SaveIcon } from "icons/Icons";

import "./AddItems.css";
import RoamingItemPopUp from "./RoamingItemPopUp/RoamingItemPopUp";

interface AddItemsProps {
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  id?: string | number;
}

const AddItems: React.FC<AddItemsProps> = ({ isModalOpen, setIsModalOpen, id }) => {
  const [isLoading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleOk = async () => {
    try {
      setIsSubmitted(true);
      setLoading(true);

      console.log("Saving items for ID:", id);

    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setIsSubmitted(false);
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <Modal
      title="Add Items"
      width="70rem"
      className="custom-modal"
      centered
      visible={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[
        <Button
          key="save"
          type="primary"
          icon={<SaveIcon />}
          onClick={handleOk}
          loading={isLoading}
        >
          Save
        </Button>,
        <Button key="cancel" icon={<CloseOutlined />} onClick={handleCancel}>
          Cancel
        </Button>,
      ]}
    >
      <RoamingItemPopUp />
    </Modal>
  );
};

export default AddItems;
